import script from "./BidViewPhases.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewPhases.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewPhases.vue?vue&type=style&index=0&id=06270b08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06270b08"]])

export default __exports__